export enum Company {
  Sea = 'C310',
  Seca = 'C330'
}


